import { CardHeader } from 'reactstrap'

const SubmissionHeader = (props) => {
  const currentCourseProgress = props.userProgress.find(
    (item) => item.course_id === props.course_id
  )
  let language = props.language || {}

  return (
    <div className=''>
      <CardHeader>
        <span className='text-info font-weight-bold'>
          {language.courses ? language.courses.total_points : null}:{' '}
          {props.quiz_score || 0} /
          {props.submissions && props.submissions.length
            ? props.submissions
                .map((item) => parseInt(item.points))
                .reduce((total, value) => total + value) || 0
            : null}
        </span>
      </CardHeader>
      <div className='col-md-10 mt-2'>
        <span
          className='submission-message'
          style={{
            color:
              props.progress_status === 2
                ? '#ff0000'
                : props.progress_status === 3
                ? '#46b943'
                : '#000',
          }}
          dangerouslySetInnerHTML={{
            __html:
              props.quiz_score_percentage >= props.quiz_pass_percentage
                ? language.courses.success_quiz_message
                : props.message,
          }}
        />
        <br />
        {currentCourseProgress && currentCourseProgress.status === 2 ? (
          <span className='submission-message'>
            {(props.retake &&
              props.quizAttempts < props.courses.quizAttemptsAllowed) ||
            (props.retake && !props.courses.quizAttemptsAllowed)
              ? language.alerts
                ? language.alerts.retake_quiz_try_again
                : null
              : language.alerts
              ? language.alerts.retake_quiz_contact_manager
              : null}
          </span>
        ) : null}
        <div
          className='total-points-mobile-wrapper'
          style={{ textAlign: 'right' }}
        >
          <span className='user-points'>
            {language.courses ? language.courses.total_points : null}:{' '}
            {props.quiz_score || 0} /{' '}
            {props.submissions && props.submissions.length
              ? props.submissions
                  .map((item) => parseInt(item.points))
                  .reduce((total, value) => total + value) || 0
              : null}
          </span>
        </div>
      </div>
    </div>
  )
}

export default SubmissionHeader
